import React from 'react';
import { Grid, List } from '@mui/material';

class CondensedListItem extends React.Component {
    state = {
    }

    render() {
        const { } = this.props

        return (
            <li>
                <Grid container>
                    {this.items()}
                </Grid>
            </li>
        );
    }

    items = () => {
        const { classes, elements } = this.props;

        return elements.map((element, i) =>
            <Grid size={{ xs: element.width, md: element.width }} key={i}>
                <List disablePadding>
                    {element.component}
                </List>
            </Grid>
        );
    }
}

export default CondensedListItem;